import { Component, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { Physician } from "src/app/models/physician";
import { AllPatient } from "src/app/models/patient";
import { VproService } from "src/app/service/vpro/vpro.service";
import { environment } from "src/environments/environment";
import { Utils } from "src/app/common/utils";
import Swal from "sweetalert2";
import { ConfirmedValidator } from "src/app/common/passwordValidator";
import moment from "moment";
import { Router } from "@angular/router";
import { CouponDetails } from "src/app/models/CouponDetails";
import { faCoffee } from "@fortawesome/free-solid-svg-icons"; //import icon
import { NgbDateStruct, NgbModal } from "@ng-bootstrap/ng-bootstrap";
const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

declare let Razorpay: any;

const appointmentDetails = [
  "first_name",
  "last_name",
  "dob",
  "email_id",
  "gender",
  "apdate",
  "aptime",
  "remarks",
  "contact_no",
  "otp",
  "type",
];
@Component({
  selector: "app-online-doctor-appointment",
  templateUrl: "./online-doctor-appointment.component.html",
  styleUrls: ["./online-doctor-appointment.component.css"],
})
export class OnlineDoctorAppointmentComponent implements OnInit {
  termsUrl = Utils.termsUrl;
  disableCheckbok: boolean;
  pid: any;
  cur_day: any;
  aptinterval: any;
  today: Date;
  nextDay: any;
  noSlotDate: any;
  constructor(
    private service: VproService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private _formBuilder: UntypedFormBuilder,
    private utils: Utils,
    private router: Router,
    private modalService: NgbModal
  ) { }
  patient: AllPatient;
  physician: Physician;
  physician_model: any = {};
  specialitiesList: any = [];
  states: any = [];
  patientForm: UntypedFormGroup;
  currentDate = Utils.maxDate;
  validOTP: boolean = false;
  phone: any;
  gender = Utils.GENDER;
  consultation = Utils.ONLINE_CONSULTATION_TYPE;
  timeSlots: any[];
  allTimeSlots: any[];
  selectedItem: any;
  aptime: any;
  endTime: any;
  maxDate = Utils.today;
  maxDates: any;
  minDate = Utils.minDobDate;
  feedbackColors = Utils.FEEDBACK_COLORS;
  starSize = Utils.STAR_SIZE;
  tAndC: boolean = false;
  create_account: boolean = false;
  loggedInPatient: boolean = false;
  wrongOTP: boolean = false;
  defaultDr = Utils.DEFAULTDR;
  appointment: any;
  isFollowup: boolean = false;
  defaultDays = Utils.DEFAULT_DAYS;
  allCouponDetails: CouponDetails[];
  revisedCharge: number;
  amountSaved: number;
  patientId: string;
  public loading: boolean = true;
  public workingHours = [];
  excludeDays: number[];
  miniDate = Utils.miniDate;
  ngOnInit() {
    this.disableCheckbok = false
    this.patientForm = this._formBuilder.group(
      {
        first_name: [
          "",
          [
            Validators.required,
            Validators.maxLength(30),
            Validators.pattern(Utils.alphaSpaceRegex),
          ],
        ],
        last_name: [
          "",
          [
            Validators.required,
            Validators.maxLength(30),
            Validators.pattern(Utils.alphaSpaceRegex),
          ],
        ],
        dob: ["", [Validators.required]],
        email_id: [
          "",
          [
            Validators.required,
            Validators.maxLength(50),
            Validators.pattern(Utils.emailpat),
          ],
        ],
        confirm_email: ["", [Validators.required, Validators.maxLength(50)]],
        gender: [""],
        apdate: ["", Validators.required],
        aptime: ["", Validators.required],
        type: ["", Validators.required],
        contact_no: [
          "",
          [
            Validators.required,
            Validators.maxLength(10),
            Validators.minLength(10),
            Validators.pattern(Utils.numberRegex),
          ],
        ],
        otp: ["", Validators.required],
        remarks: ["", Validators.required],
        drug_allergy: ["", Validators.required],
        couponSelected: [""],
        revisedChargeField: [{ value: "", disabled: true }],
      },
      {
        validator: ConfirmedValidator("email_id", "confirm_email"),
      }
    );

    if (localStorage.getItem("uid")) {
      this.patientId = JSON.parse(localStorage.getItem("uid"));
    }

    if (this.route.snapshot.queryParams["followup"]) {
      this.isFollowup = true;
      this.getAppointment();
    } else {
      this.getPhysician();
    }
  }
  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }
  checkPatientData() {
    // check if we details of failed transaction
    let data = localStorage.getItem("onlineAppointment");
    if (data) {
      if (
        localStorage.getItem("LogUsrTyp") &&
        this.utils.checkRoleType(
          Utils.USER_TYPE.patient,
          JSON.parse(localStorage.getItem("LogUsrTyp"))
        )
      )
        this.loggedInPatient = true;
      let params = JSON.parse(data);
      if (params["email_id"]) params["confirm_email"] = params["email_id"];
      if (Object.keys(data).length > 0) {
        this.patientForm.patchValue(params);
      }
      this.otpValidated();
      this.getTimeSlots();
    }

    // check if it is a follow up appointment
    else if (this.isFollowup) {
      let { patient_details } = this.appointment;
      patient_details.confirm_email = patient_details.email_id;
      let dataToPatch = [
        "first_name",
        "last_name",
        "email_id",
        "gender",
        "dob",
        "confirm_email",
      ];
      let params = {};
      for (let field of dataToPatch) {
        if (patient_details[field]) params[field] = patient_details[field];
        this.patientForm.controls[field].disable();
      }
      this.patientForm.patchValue(params);
      if (this.appointment && this.appointment.followup_date) {
        let fdate = moment(this.appointment.followup_date).format("DD/MM/YYYY");
        let start = moment(fdate, "DD/MM/YYYY").toDate();
        this.maxDates = {
          year: start.getFullYear(),
          month: start.getMonth() + 1,
          day: start.getDate(),
        };
      }
    }
    // check if patient is already logged in
    else if (
      localStorage.getItem("LogUsrTyp") &&
      this.utils.checkRoutesAccess(
        JSON.parse(localStorage.getItem("LogUsrTyp")),
        [Utils.USER_TYPE.patient]
      )
    ) {
      if (localStorage.getItem("uid")) {
        //  check if appointment is booked for self or relative
        let selectedPid = this.route.snapshot.queryParams["pid"]
          ? this.route.snapshot.queryParams["pid"]
          : JSON.parse(localStorage.getItem("uid"));
        this.pid = selectedPid;
        this.service.getPatientById(selectedPid).subscribe(
          (res) => {
            if (res && Object.keys(res).length > 0) {
              this.patient = res
              this.loggedInPatient = true;
              let dataToPatch = [
                "first_name",
                "last_name",
                "email_id",
                "gender",
                "contact_no",
                "dob",
                "confirm_email",
              ];
              let patchVal = {};
              for (let val of dataToPatch) {
                if (res["email_id"]) res["confirm_email"] = res["email_id"];
                this.patientForm.controls[val].disable();
                if (this.patient[val] !== this.patient['dob']) {
                  if (this.patient[val]) patchVal[val] = this.patient[val];
                }
              }
              let startDate = this.patient['dob'].split('-');
              this.patientForm.patchValue({
                dob: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }
              })
              this.patientForm.patchValue(patchVal);
              this.otpValidated();
            }
          },
          (err) => { }
        );
      }
    }

    this.fetchPatDiscountCoupons();
  }
  ngOnDestroy() {
    let onlineData = localStorage.getItem("onlineAppointment");
    if (onlineData) {
      localStorage.removeItem("onlineAppointment");
    }
  }

  getAppointment() {
    this.spinner.show();
    this.service
      .getAppointmentDetails({
        aptid: this.route.snapshot.queryParams["followup"],
        fields: ["physician_details", "patient_details"],
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.appointment = res;
          console.log("res----------", res)
          this.getDefaultWorkingHours(this.appointment.drid);
          if (
            this.appointment &&
            this.appointment.schedule_stat &&
            this.appointment.schedule_stat !== "pending"
          )
            this.showToast("error", "Appointment is already booked.");

          if (this.appointment && this.appointment.physician_details) {
            this.physician = this.appointment.physician_details;
            this.setPhysicianDetail();
          }

          if (this.appointment && this.appointment.patient_details)
            this.checkPatientData();
        },
        (error) => {
          this.spinner.hide();
          this.showToast("error", "Something went wrong. Please try again.");
        }
      );
  }

  tncChecked(evt) {
    let target = evt.target;
    this.tAndC = target.checked;
  }

  getPhysician() {
    this.spinner.show();
    this.service
      .getPhysicianById(
        this.route.snapshot.params["id"],
        "?verified=true&fields=status,consult_fee,ratings"
      )
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.loading = false;
          this.physician = res;


          console.log("this.physician this.physician", this.physician)
          let interval_apt = this.physician?.aptinterval ?? 0
          this.today = new Date(); // Sets today's date
          this.nextDay = new Date(this.today);
          this.nextDay.setDate(this.today.getDate() + interval_apt);
          const dateObject = new Date(this.nextDay);
          const year = dateObject.getFullYear();
          const month = dateObject.getMonth() + 1; // Months are zero-indexed, so adding 1
          const day = dateObject.getDate();
          this.aptinterval = {
            year: year,
            month: month,
            day: day,
          };
          console.log("this.aptinterval", this.aptinterval)
          this.getDefaultWorkingHours(this.physician.u_id);
          this.checkPatientData();
          this.setPhysicianDetail();
          this.getAllTimeSlots();
        },
        (error) => {
          this.spinner.hide();
          this.loading = false;
          let msg =
            error && error.error && error.error.message
              ? error.error.message
              : "Something went wrong. Please try again.";
          this.showToast("error", msg);
        }
      );
  }
  shareProfile(e, type) {
    let url: string;
    switch (type) {
      case "facebook":
        url = Utils.SHARE_URL.FACEBOOK + window.location.href;
        break;
      case "twitter":
        url = Utils.SHARE_URL.TWITTER + window.location.href;
        break;
      case "linkedin":
        url = Utils.SHARE_URL.LINKEDIN + window.location.href;
        break;
      case "pinterest":
        url = Utils.SHARE_URL.PINTREST + window.location.href;
        break;
      case "whatsapp":
        url = Utils.SHARE_URL.WHATSAPP + window.location.href;
        break;
      case "mail":
        url = Utils.SHARE_URL.MAIL + window.location.href;
        break;
    }

    e.preventDefault();
    const shareWindow = window.open(
      url,
      "facebook-popup",
      "height=350,width=600"
    );
    if (shareWindow.focus) {
      shareWindow.focus();
    }
    return false;
  }

  setPhysicianDetail() {
    if (
      this.physician &&
      this.physician.physician_qualification &&
      this.physician.physician_qualification.length
    ) {
      this.physician.qualification =
        this.physician.physician_qualification[0].qualification;
    }

    if (
      this.physician &&
      this.physician.physician_education &&
      this.physician.physician_education.length
    ) {
      this.physician_model.education = this.physician.physician_education
        .map((x) => x.degree)
        .join(", ");
      this.physician_model.university = this.physician.physician_education
        .map((x) => x.institution)
        .join(", ");
    }

    if (
      this.physician &&
      this.physician.physician_speciality &&
      this.physician.physician_speciality.length
    ) {
      this.getSpecialitiesList();
    }

    if (this.physician && this.physician.state) {
      this.loadStates();
    }

    // setting appointment fees
    if (this.route.snapshot.queryParams["followup"]) {
      this.physician.consult_fee = this.appointment.fee;
    }

    if (this.physician.consult_fee) {
      let extra_charges = this.physician.consultation_share
        ? (1 - parseFloat(this.physician.consultation_share)) *
        this.physician.consult_fee
        : 0;
      this.physician.consult_fee = this.physician.consult_fee + extra_charges;
    }

    this.physician.consult_fee = Math.ceil(this.physician.consult_fee);
  }
  getSpecialitiesList() {
    this.spinner.show();
    this.service.getSpecialitiesList().subscribe(
      (res) => {
        this.spinner.hide();
        this.specialitiesList = res;
        //Map Specialities
        let specialities = [];
        this.physician.physician_speciality.forEach((element) => {
          let sp = this.specialitiesList.find(
            (s) => s.id == element.speciality_id
          );
          specialities.push(`${sp.name} - ${element.no_of_years}Years`);
        });
        this.physician_model.speciality = specialities.join(", ");
      },
      (error) => {
        this.spinner.hide();
      }
    );
  }

  loadStates() {
    this.service.getStates(1).subscribe((res) => {
      this.states = res;
      this.physician_model.location = this.states.find(
        (x) => x.id == this.physician.state
      );
      this.physician_model.location = ", " + this.physician_model.location.name;
    });
  }

  requestOTP() {
    if (this.patientForm.value.contact_no) {
      if (this.patientForm.value.otp) return;

      if (
        !this.patientForm.value.contact_no.match(Utils.numberRegex) ||
        this.patientForm.value.contact_no.length != 10
      ) {
        this.showToast(
          "error",
          "Invalid Contact No, Please enter a valid contact number"
        );
        this.patientForm.controls["contact_no"].reset();
        return;
      }

      this.spinner.show();
      this.service
        .requestOTP({ contact_no: this.patientForm.value.contact_no })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
          },
          (error) => {
            this.spinner.hide();
            this.showToast("error", "Something went wrong. Please try again.");
          }
        );
    }
  }

  validateOTP() {
    if (this.validOTP) return;
    if (this.patientForm.value.contact_no && this.patientForm.value.otp) {
      this.spinner.show();
      this.service
        .validateOTP({
          contact_no: this.patientForm.value.contact_no,
          otp: this.patientForm.value.otp,
        })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast("success", res.message);
            this.otpValidated();
          },
          (err) => {
            this.spinner.hide();
            let message =
              err && err.error && err.error.message && err.error.message.message
                ? err.error.message.message
                : "Something wrong. Couldn't delete appointment.";
            this.showToast("error", message);
            if (err.error.message.message) {
              this.wrongOTP = true;
              return;
            }
          }
        );
    }
  }

  otpValidated() {
    this.wrongOTP = false;
    this.phone = this.patientForm.getRawValue().contact_no;
    this.patientForm.controls["contact_no"].disable();
    this.patientForm.controls["otp"].disable();
    this.validOTP = true;
  }

  isDateDisabled = (date: NgbDateStruct) => {
    // Check if the input date matches any date in noSlotDate array
    const isDisabledDate = this.noSlotDate.some((disableDate: { date: string | number | Date; }) => {
      return (
        date.year === new Date(disableDate.date).getFullYear() &&
        date.month === new Date(disableDate.date).getMonth() + 1 &&
        date.day === new Date(disableDate.date).getDate()
      );
    });
    // Check if the date falls on a weekend
    const isWeekend = this.disableWeekends(date);
    // Return true if either condition is met (date is disabled or it's a weekend)
    return isDisabledDate || isWeekend;
  };
  disableWeekends = (date: NgbDateStruct) => {
    const day = new Date(date.year, date.month - 1, date.day).getDay();
    return this.excludeDays.includes(day);
  }
  getDefaultWorkingHours(dr_id) {
    let drid = dr_id;
    this.spinner.show();
    this.service.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          //console.log("this.workingHours", this.workingHours)
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
          });
        }
        this.excludeDays = this.workingHours.filter(day => day.Checked).map(day => day.day);

        console.log("getWorkingHours", this.workingHours);
        console.log("excludeDays", this.excludeDays);


      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }

  // disableWeekends = (date: NgbDateStruct) => {
  //   const day = new Date(date.year, date.month - 1, date.day).getDay();
  //   // Disable Saturday and Sunday
  //   return day === 0 || day === 6;
  // }
  getAllTimeSlots() {
    this.spinner.show();
    console.log("currentDate", this.currentDate)
    this.service
      .getallappoint({
        drid: this.physician.u_id,
        cur_date: `${this.currentDate.year}-${this.currentDate.month}-${this.currentDate.day}`,
        days: `30`,
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.allTimeSlots = res;
          console.log("this.allTimeSlots", this.allTimeSlots)

          // Split the array based on slotCount === 0
          const splitData = this.allTimeSlots.reduce((acc, obj) => {
            if (obj.slotCount === 0) {
              acc.zero.push(obj);
            } else {
              acc.nonZero.push(obj);
            }
            return acc;
          }, { zero: [], nonZero: [] });
          this.noSlotDate = splitData.zero
          console.log("splitData.zero", splitData.zero); // Array of objects with slotCount === 0
          console.log("splitData.nonZero", splitData.nonZero);
        },
        (error) => {
          this.spinner.hide();
          this.showToast(
            "error",
            "Something went wrong while fetching time slots. Please try again."
          );
        }
      );
  }
  getTimeSlots() {
    let { year, month, day } = this.patientForm.getRawValue().apdate;
    this.spinner.show();
    this.service
      .getappoint({
        drid: this.physician.u_id,
        date: `${year}-${month}-${day}`,
      })
      .subscribe(
        (res) => {
          this.spinner.hide();
          this.timeSlots = res;
          if (!(res && res.length)) {
            Swal.fire({
              type: "warning",
              title: "Oops...",
              text: "No timeslots available for this day!",
            });
          }
          this.selectedItem = null;
          this.patientForm.get("aptime").reset();
          this.endTime = null;
          this.getSelectedSlot();
        },
        (error) => {
          this.spinner.hide();
          this.showToast(
            "error",
            "Something went wrong while fetching time slots. Please try again."
          );
        }
      );
  }

  getSelectedSlot() {
    let onlineData = localStorage.getItem("onlineAppointment");
    if (onlineData) {
      let aptime = JSON.parse(onlineData).aptime;
      let index;
      this.timeSlots.forEach((slot, i) => {
        if (slot.start_time === aptime) {
          index = i;
        }
      });
      this.TimeSlotSelected(index);
    }
  }

  TimeSlotSelected(i) {
    this.selectedItem = i;
    if (
      this.timeSlots[i] &&
      this.timeSlots[i].start_time &&
      this.timeSlots[i].end_time
    ) {
      this.patientForm.patchValue({
        aptime: this.timeSlots[i]["start_time"],
      });
      this.endTime = this.timeSlots[i]["end_time"];
    }
  }

  isSelectedItem(i) {
    return this.selectedItem === i;
  }

  pay() {
    if (this.route.snapshot.queryParams["followup"]) {
      this.updateAppointment();
      return;
    }
    this.addAppointment();
  }

  updateAppointment() {
    let { year, month, day } = this.patientForm.getRawValue().apdate;
    let ctype = this.consultation.find(
      (x) => x.value === this.patientForm.getRawValue().type
    );
    let body = {
      drid: this.physician.u_id,
      aptname: `${ctype.key} Call : ${this.patientForm.getRawValue().first_name
        } ${this.patientForm.getRawValue().last_name}`,
      apdate: `${year}-${month}-${day}`,
      aptime: this.patientForm.getRawValue().aptime,
      endtime: this.endTime,
      apttype: this.patientForm.getRawValue().type,
      remarks: this.patientForm.getRawValue().remarks,
      drug_allergy:
        this.patientForm.getRawValue().drug_allergy === "yes" ? true : false,
      coupon_id: this.patientForm.get("couponSelected").value.id,
      parent_pid: this.patientId,
      status:
        this.physician.consult_fee && this.physician.consult_fee > 0
          ? Utils.APPOINTMENT_STATUS.DRAFT
          : Utils.APPOINTMENT_STATUS.APPROVAL_REQUESTED,
    };

    this.spinner.show();
    let charge = false;
    if (this.physician.consult_fee) {
      charge = true;
      if (this.patientForm && this.patientForm.get("couponSelected") && this.patientForm.get("couponSelected").value.discount_percent === 100) {
        charge = false;
      }
    }

    this.service.editSchedule(body, this.appointment.aid, "charge").subscribe(
      (res) => {
        this.spinner.hide();
        if (this.physician.consult_fee && this.physician.consult_fee > 0 && charge) {
          this.doPayment(res);
          return;
        }
        this.router.navigate(["/invoice"], {
          queryParams: {
            aptid: res["aptid"],
            amount: 0,
            currency: "INR",
            issue_date: moment().format("DD/MM/YYYY"),
          },
        });
      },
      (err) => {
        this.spinner.hide();
        let message = "Something wrong. Couldn't schedule appointment.";
        if (err && err.error && err.error.error) {
          this.showToast("error", err.error.error);
          return;
        }
        this.showToast("error", message);
      }
    );
  }

  addAppointment() {
    let { year, month, day } = this.patientForm.getRawValue().apdate;
    let dob;
    if (this.patientForm.getRawValue().dob) {
      dob = this.patientForm.getRawValue().dob.year + "-" + this.patientForm.getRawValue().dob.month + "-" + this.patientForm.getRawValue().dob.day
    }
    let ctype = this.consultation.find(
      (x) => x.value === this.patientForm.getRawValue().type
    );
    let body = {
      drid: this.physician.u_id,
      aptname: `${ctype.key} Call : ${this.patientForm.getRawValue().first_name
        } ${this.patientForm.getRawValue().last_name}`,
      apdate: `${year}-${month}-${day}`,
      aptime: this.patientForm.getRawValue().aptime,
      endtime: this.endTime,
      type: this.patientForm.getRawValue().type,
      remarks: this.patientForm.getRawValue().remarks,
      drug_allergy:
        this.patientForm.getRawValue().drug_allergy === "yes" ? true : false,
        createdat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day,
      patDetails: {
        first_name: this.patientForm.getRawValue().first_name,
        last_name: this.patientForm.getRawValue().last_name,
        contact_no: this.phone,
        email_id: this.patientForm.getRawValue().email_id,
        gender: this.patientForm.getRawValue().gender,
        dob: dob,
      },
      coupon_id: this.patientForm.get("couponSelected").value.id,
      parent_pid: this.patientId,
      selectedPid: this.pid,
    };
    if (this.create_account) body["create_account"] = this.create_account;
    this.spinner.show();
    let charge = false;
    if (this.physician.consult_fee) {
      charge = true;
      if (this.patientForm && this.patientForm.get("couponSelected") && this.patientForm.get("couponSelected").value.discount_percent === 100) {
        charge = false;
      }
    }
    console.log("SCHEDULE APPOINTMNET", body);
    this.service
      .addSchedule(body, charge ? "charge" : "")
      .subscribe(
        (res) => {
          this.spinner.hide();
          if (this.physician.consult_fee && this.physician.consult_fee > 0 && charge) {
            this.doPayment(res);
            return;
          }

          this.router.navigate(["/invoice"], {
            queryParams: {
              aptid: res["aptid"],
              amount: 0,
              currency: "INR",
              issue_date: moment().format("DD/MM/YYYY"),
            },
          });
        },
        (err) => {
          this.spinner.hide();
          let message = "Something wrong. Couldn't schedule appointment.";
          if (err && err.error && err.error.error) {
            this.showToast("error", err.error.error);
            return;
          }
          this.showToast("error", message);
        }
      );
  }

  doPayment(params) {
    let { aid, orderId, aptid } = params;
    if (aid && orderId && aptid) {
      let options = {
        key: environment.razorpay_key,
        amount:
          this.physician.consult_fee * Utils.PAYMENT_CONFIG.AMOUNT_CONVERT,
        currency: Utils.PAYMENT_CONFIG.CURRENCY,
        name: Utils.PAYMENT_CONFIG.NAME,
        description: "Book Appointment",
        order_id: orderId,
        callback_url: `${environment.api_base_url3}${environment.razorpay_callback_url}`,
        prefill: {
          name: `${this.patientForm.getRawValue().first_name} ${this.patientForm.getRawValue().last_name
            }`,
          email: this.patientForm.getRawValue().email_id,
          contact: this.phone,
        },
        notes: {
          aid: aid,
          aptid: aptid,
          first_name: this.patientForm.getRawValue().first_name,
          last_name: this.patientForm.getRawValue().last_name,
          coupon_id: this.patientForm.get("couponSelected").value.id,
          parent_pid: this.patientId,
        },
        modal: {
          ondismiss: () => {
            console.log(`Checkout form closed`);
            // delete apt if pop up closed
            this.spinner.show();
            /* call delete coupon api */
            let onlineData = localStorage.getItem("onlineAppointment");
            if (onlineData) {
              localStorage.removeItem("onlineAppointment");
            }
            if (this.patientForm.get("couponSelected").value.id) {
              this.service
                .deleteCouponUsage(
                  this.patientForm.get("couponSelected").value.id,
                  this.patientId
                )
                .subscribe(
                  (res) => {
                    console.log(res);
                  },
                  (err) => {
                    console.log(err);
                  }
                );
            }
            if (this.isFollowup) {
              let { year, month, day } = this.patientForm.getRawValue().apdate;
              let ctype = this.consultation.find(
                (x) => x.value === this.patientForm.getRawValue().type
              );
              let body = {
                drid: this.physician.u_id,
                aptname: `${ctype.key} Call : ${this.patientForm.getRawValue().first_name
                  } ${this.patientForm.getRawValue().last_name}`,
                apdate: `${year}-${month}-${day}`,
                aptime: this.patientForm.getRawValue().aptime,
                endtime: this.endTime,
                apttype: this.patientForm.getRawValue().type,
                status: Utils.APPOINTMENT_STATUS.PENDING,
              };

              this.service.editSchedule(body, this.appointment.aid).subscribe(
                (res) => {
                  this.spinner.hide();
                },
                (err) => {
                  this.spinner.hide();
                }
              );
            } else {
              this.service.deleteAppointment(aid, null).subscribe(
                (res) => {
                  this.spinner.hide();
                },
                (err) => {
                  this.spinner.hide();
                }
              );
            }
          },
        },
      };
      this.storeFormDetails();
      let rzp1 = new Razorpay(options);
      rzp1.on("payment.failed", function (response) {
        window.location.reload();
      });
      rzp1.open();
    }
  }

  storeFormDetails() {
    let details = {};
    for (let key of appointmentDetails) {
      details[key] = this.patientForm.getRawValue()[key];
    }
    details["contact_no"] = this.phone;
    localStorage.setItem("onlineAppointment", JSON.stringify(details));
  }

  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title,
    });
  }

  tacChecked(evt) {
    let target = evt.target;
    this.tAndC = target.checked;
  }

  createAccountCheck(evt) {
    let target = evt.target;
    this.create_account = target.checked;
  }

  fetchPatDiscountCoupons() {
    let queryParam: string = "";

    if (this.isFollowup) {
      this.patientId = this.appointment.patient_details.parent_pid;
    } else {
      this.patientId = JSON.parse(localStorage.getItem("uid"));
    }
    queryParam = `?pid=${this.patientId}`;
    this.spinner.show();
    this.service.fetchCoupons(queryParam).subscribe(
      (res) => {
        this.spinner.hide();
        this.allCouponDetails = res;
      },
      (err) => {
        console.log(err);
        this.spinner.hide();
        //this.showToast('error', "No Discount Coupons Available");
      }
    );
  }

  calculateRevisedAmount(index) {
    let discountPercent =
      this.patientForm.get("couponSelected").value.discount_percent;
    this.amountSaved = (this.physician.consult_fee * discountPercent) / 100;
    this.revisedCharge = Math.ceil(
      this.physician.consult_fee - this.amountSaved
    );
    this.amountSaved = this.physician.consult_fee - this.revisedCharge;
  }
  reDirect() {
    this.router.navigate(["/login"])
  }

  emailvalid(content) {
    if (this.patientForm.value.email_id) {
      this.spinner.show();
      this.service
        .emailvaild({ email_id: this.patientForm.value.email_id })
        .subscribe(
          (res) => {
            this.spinner.hide();
            this.showToast('success', "Welcome To ReliableDRS");
            this.disableCheckbok = false
          },
          (error) => {
            this.spinner.hide();

            this.modalService.open(content, { centered: true }).result.then(
              (result) => {
                console.log("result", result);

              },
              (reason) => {
                console.log("reason", reason);

                this.disableCheckbok = true;
              }
            );
          }
        );

    }
  }








}
